<script>
import Loader from "@/components/custom/Loader.vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
export default {
  name: "SkillAddModal",
  props: {
    value: Boolean,
    selectedId: Number,
  },
  data() {
    return {
      invalid: true,
      load: false,
      skill_id: 0,
      skill_level_id: 0,
      submitted: false,
    };
  },
  computed: {
    ...mapGetters(["isLoadingGet", "skillsListGet", "skillLevelsListGet"]),
    isLoading() {
      return this.isLoadingGet;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  watch: {
    isLoading(isLoading) {
      if (isLoading) {
        this.load = true;
      } else {
        this.load = false;
      }
    },
  },
  mounted() {
    this.skillsListGet.length == 0 ? this.getSkills({ isModal: true }) : null;
    this.skillLevelsListGet.length == 0
      ? this.getSkillLevels({ isModal: true })
      : null;
  },
  methods: {
    ...mapMutations(["SET_LOADING"]),
    ...mapActions([
      "getSkills",
      "getSkillLevels",
      "addEmployeeSkill",
      "set_page",
    ]),
    agree() {
      const request = {
        employee_id: this.$props.selectedId,
        skill_id: this.skill_id,
        skill_level_id: this.skill_level_id,
      };
      this.$refs.observer.validate();
      this.SET_LOADING(true);
      this.addEmployeeSkill(request);
      this.show = false;
    },
    cancel() {
      this.show = false;
    },
  },
  components: {
    Loader,
  },
};
</script>
<style scoped>
.v-select {
  height: 54px;
  border-radius: 5px;
  background-color: white !important;
}
</style>
<template>
  <v-dialog v-model="show" max-width="500px">
    <Loader v-if="load" />
    <v-card v-else class="backGround">
      <v-toolbar dark color="prime" dense flat></v-toolbar>
      <v-card-text class="pa-4 mt-6 prime--text">{{
        $t("addSkills")
      }}</v-card-text>
      <ValidationObserver ref="observer" v-slot="{ invalid }">
        <v-form @submit.prevent="agree">
          <template>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <validation-provider
                    v-slot="{ errors, valid }"
                    name="skillId"
                    rules="required"
                  >
                    <v-select
                      id="skillId"
                      :error-messages="errors"
                      :rules="[(v) => !!v || $t('requiredField')]"
                      :state="errors[0] ? false : valid ? true : null"
                      v-model="skill_id"
                      :label="$t('skills')"
                      :items="skillsListGet"
                      item-text="name"
                      item-value="id"
                      persistent-hint
                      outlined
                      color="orange"
                      item-color="orange"
                      class="ma-1"
                    >
                      <template v-slot:item="{ item, on, attrs }">
                        <v-list-item v-on="on">
                          <v-list-item-action>
                            <v-simple-checkbox
                              :value="attrs.inputValue"
                              v-on="on"
                              color="orange"
                              :ripple="false"
                            ></v-simple-checkbox>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title
                              :class="attrs.inputValue ? 'orange--text' : ''"
                              >{{ $t(item.name) }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select></validation-provider
                  ></v-col
                >
                <v-col cols="12" md="6">
                  <validation-provider
                    v-slot="{ errors, valid }"
                    name="skillLevels"
                    rules="required"
                  >
                    <v-select
                      id="skillLevels"
                      :error-messages="errors"
                      :rules="[(v) => !!v || $t('requiredField')]"
                      :state="errors[0] ? false : valid ? true : null"
                      v-model="skill_level_id"
                      :label="$t('skillLevels')"
                      :items="skillLevelsListGet"
                      item-text="description"
                      item-value="id"
                      persistent-hint
                      outlined
                      color="orange"
                      item-color="orange"
                      class="ma-1"
                    >
                      <template v-slot:item="{ item, on, attrs }">
                        <v-list-item v-on="on">
                          <v-list-item-action>
                            <v-simple-checkbox
                              :value="attrs.inputValue"
                              v-on="on"
                              color="orange"
                              :ripple="false"
                            ></v-simple-checkbox>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title
                              :class="attrs.inputValue ? 'orange--text' : ''"
                              >{{ $t(item.number) }}</v-list-item-title
                            >
                          </v-list-item-content>
                        </v-list-item>
                      </template>
                    </v-select></validation-provider
                  ></v-col
                >
              </v-row>
            </v-container>
          </template>
          <v-card-actions class="pt-3">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              id="cancelBtn"
              class="font-weight-bold"
              @click.native="cancel"
              >{{ $t("cancel") }}</v-btn
            >
            <v-btn
              color="orange"
              class="font-weight-bold"
              outlined
              type="submit"
              id="agreeBtn"
              :disabled="invalid"
              @click.native="agree"
              >{{ $t("confirm") }}</v-btn
            >
          </v-card-actions>
        </v-form></ValidationObserver
      >
    </v-card>
  </v-dialog>
</template>
